/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {CustomFunction} from '../models/customFunction';

export class CustomFunctionStore extends EntityStore {
  customFunctions = [];

  constructor(rootStore) {
    super(rootStore, 'customFunctions', Api.customFunctions, CustomFunction, true);
  }
}

decorate(CustomFunctionStore, {
  customFunctions: observable,
});
